import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface Props {
    placeholderText: string;
    selectedDate: Date | null;
    onChange: (data: Date | null) => void;
    dateFormat?: string;
}

const CustomDatePicker: React.FC<Props> = ({ onChange, placeholderText, selectedDate, dateFormat }) => {
    return (
        <DatePicker
            selected={selectedDate}
            onChange={onChange}
            className="rounded cursor-pointer py-2 px-5 sm:px-3 w-full  md:w-[6rem] border border-primary-border text-sm"
            placeholderText={placeholderText}
            dateFormat={dateFormat}
        />
    );
};

export default CustomDatePicker;
